export default __webpack_public_path__ + "static/media/photographer.b79823df.png";